import React from 'react';
import { useIntl } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data';

import { ModalMode, MinimizableModal } from '../../minimizable-modal';
import { STANDARD_DIFF_ANALYTICS_SOURCE } from '../differentiators-modal';

import { messages } from './messages';

const ContainerStyles = xcss({
	position: 'fixed',
	right: '12px',
	bottom: '12px',
	zIndex: 'modal',
});

type Props = {
	onClose: () => void;
	hasBillingInfo: boolean | null;
	touchpointId: string;
};

export const VideoTutorialModal = ({ onClose, hasBillingInfo, touchpointId }: Props) => {
	const { locale } = useSessionData();

	const { formatMessage } = useIntl();

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClose = () => {
		onClose();
	};

	const handleModeChange = (mode: ModalMode) => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'videoTutorialModalMode',
				attributes: {
					billingInfo: hasBillingInfo,
					source: STANDARD_DIFF_ANALYTICS_SOURCE,
					touchpointId,
					mode,
				},
			},
		}).fire();
	};

	const getVideoUrl = (locale: string) => {
		const videoUrl = 'https://www.youtube-nocookie.com/embed/bi14y3jOXMM?rel=0&modestbranding=1';

		if (locale !== 'en-US') {
			return `${videoUrl}&cc_load_policy=1&cc_lang_pref=${locale}&hl=${locale}&cc=on`;
		}

		return videoUrl;
	};

	return (
		<Box xcss={ContainerStyles}>
			<MinimizableModal
				testId="experiment-standard-differentiators.ui.video-tutorial.modal"
				title={formatMessage(messages.videoTitle)}
				defaultMode={ModalMode.DEFAULT}
				onClose={handleClose}
				onModeChange={handleModeChange}
			>
				<iframe
					width="100%"
					height="100%"
					src={getVideoUrl(locale)}
					title={formatMessage(messages.videoTitle)}
					frameBorder="0"
					allowFullScreen
				/>
			</MinimizableModal>
		</Box>
	);
};
